module.exports = __webpack_public_path__ + "img/14.579eed08.png";